import { useCallback } from "react";
import { useAPI } from "kw/api/useAPI";
import { userFields } from "kw/api/fragments";
import { setBearer } from "kw/api";
import { toLocalStorage } from "kanopi-components/utils/browser";
import { useGlobal } from "kanopi-components/useGlobal";
import { useNavigate } from "@reach/router";

export const useReleaseHijack = (releaseToUrl: string | null = null) => {
  const { mutation } = useAPI();
  const [, setAuth] = useGlobal("auth");
  const navigate = useNavigate();

  const releaseUser = useCallback(() => {
    mutation(
      {
        releaseUser: {
          token: true,
          user: userFields,
        },
      },
      async (response) => {
        if (response?.releaseUser?.token) {
          setBearer(response.releaseUser.token);
          toLocalStorage("auth", response.releaseUser);
          await setAuth(response.releaseUser);
          if (releaseToUrl) {
            navigate(`${releaseToUrl}`);
          }
        }
      }
    );
  }, [mutation, setAuth, navigate, releaseToUrl]);

  return { releaseUser };
};
